import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import {computed, ref, onMounted, Ref} from 'vue';
import { useRootStore } from '@/store';
import { Modal, SignatureData } from '@/store/classes';
import { SignatureDocumentFieldType } from '@/store/enums';
import { BLANK_IMG } from '@/components/common/schemas';
import { usePortalIntakeStore } from '@/store/PortalIntakeModule';
import { ERROR_ANCHOR_CLASS } from '@/components/common/FormValidation';
import FormField from "@/components/common/FormField.vue3.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientSignature.vue3',
  props: {
    height: { default: 90 },
    mode: { default: 'signature' },
    value: {},
    documentIndex: {},
    fieldIndex: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const intakeStore = usePortalIntakeStore();
const patientSignature = computed(() => intakeStore.state.patientSignature);
const patientInitials = computed(() => intakeStore.state.patientInitials)
const setPatientSignature = (signature: SignatureData) => intakeStore.dispatch('setPatientSignature', signature);
const setPatientInitials = (initials: SignatureData) => intakeStore.dispatch('setPatientInitials', initials);
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) =>
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

const width = computed(() => props.height * (props.mode === 'signature' ? 5.5 : 2.5));
const displayHeight = computed(() => props.height * .75)
const displayWidth = computed(() => width.value * .75);

const rootStore = useRootStore();
const showModal = (modal: Modal) => rootStore.dispatch('showModal', modal);
const currentModal = computed(() => rootStore.state.currentModal);
const imgSrc = ref(BLANK_IMG);
const isEmpty = (src = imgSrc.value) => !src || src === BLANK_IMG;

const validationState = computed(() => intakeStore.getters.getSignatureFieldValidationState({ docIndex: props.documentIndex, fieldIndex: props.fieldIndex }));

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.Signature, value: imgSrc})
);

async function openSignatureModal() {
    if (currentModal.value?.name === 'SurveyPreviewModal') 
        return; // don't open if we're in the preview modal

    const storedSignature = props.mode === 'initials' ? patientInitials.value : patientSignature.value;
    const newSig: SignatureData = await showModal({
        name: 'SignatureModal',
        props: {
            storedSignature,
            isInitials: props.mode === 'initials',

            width: width.value,
            height: props.height,
        }
    });

    imgSrc.value = newSig.imgSrc;

    if (!isEmpty(newSig.imgSrc) || !!newSig.text) {
        if (props.mode === 'initials')
            setPatientInitials(newSig);
        else
            setPatientSignature(newSig);
    }

    emit('update');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormField, { "validation-state": validationState.value }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["signature-container signature-form-signature", [
                props.mode === 'initials' ? 'signature-initials' : 'signature-full',
                (validationState.value?.invalid && validationState.value?.submitAttempted) && (_unref(ERROR_ANCHOR_CLASS) + ' field-validation-error'),
                isEmpty() && 'placeholder-visible'

            ]]),
        style: _normalizeStyle({ maxWidth: displayWidth.value + 'px', maxHeight: displayHeight.value + 'px'}),
        onClick: _cache[0] || (_cache[0] = () => openSignatureModal())
      }, [
        _createElementVNode("img", {
          src: imgSrc.value,
          class: "signature-image",
          width: displayWidth.value,
          height: displayHeight.value,
          style: {"margin-top":"-1px","margin-left":"-1px"}
        }, null, 8, _hoisted_1)
      ], 6)
    ]),
    _: 1
  }, 8, ["validation-state"]))
}
}

})